export const SET_MESSAGE_ALERT_ACTION_TYPE = 'SET_MESSAGE_ALERT_TYPE';

export const setMessage = ({ message, maxWidth, buttonText = null }) => ({
  type: SET_MESSAGE_ALERT_ACTION_TYPE,
  payload: { message, maxWidth, buttonText },
});

export const setMessageExportUnavailable = () => setMessage({ message: 'The exporting service is not available. \n Please, try again later.' });

export const setMessageListUnavailable = () => setMessage({ message: 'Couldn\'t get item list. \n Please, try again later.' });

export const setMessageDataUnavailable = () => setMessage({ message: 'Couldn\'t get data. \n Please, try again later.' });
